import React from "react";
import { Row, Col } from "antd";
import Img from "../../image/donation/choose.png";

const Choose= () => {
  return (
       <section  className="extra-effort py-[80px] px-[1rem]">
      <div className="container m-auto">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="center"
          className="overflow-hidden"
        >
          {/* Left: Image */}
           <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="mission-images">
              <img
                src={Img}
                className="w-[100%] lg:w-[90%]  h-[90%] object-contain rounded-lg "
                alt="img"
              />
            </div>
          </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="banner-text">
                <h4 className="font-outfit text-sm  md:text-base text-[#555]">
               Ways to Give
               </h4> 
              <h2 className="text-[40px] lg:text-[60px] font-cinzel text-start">
               Choose How You’d <br /> Like to Support
              </h2>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit ">
             Every contribution is meaningful and appreciated.              </p>
               <div className="flex flex-col gap-[1rem]">
                    <p className="font-outfit text-[18px]">Donation Options:</p>
                   <div className="flex flex-wrap gap-[15px]">
                          <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              $10
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              $25
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              $50
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              $100
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              CUSTOM AMOUNT
                          </button>
                   </div>
               </div>
               <button
          className="mt-[45px] text-black font-outfit font-semibold px-6 py-3 rounded-full 
             shadow-md transition-all duration-500 bg-gradient-to-r from-[#00F0FB] via-white to-[#00F0FB]
             bg-[length:200%_200%] bg-left hover:bg-right hover:scale-105"
        >
          Donate
        </button>
               
            </div>
             {/* Right: Text */}
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default Choose;
